module.exports = __webpack_public_path__ + "img/british-admiral-richard-howe.4aa66cc9.png";